import * as React from 'react';

import { useLockFn } from 'ahooks';
import { Flex, Form, notification } from 'antd';
import { useNavigate } from 'react-router-dom';

import { PrimitiveForm } from 'components';
import { useProductCommentValue } from 'context';
import { updateProductComment } from 'services';
import { parseFromContent, PATHNAME } from 'utils';

import { ProductCommentFormAction } from './action';
import { ProductCommentFormContent } from './content';

const {
  LOCAL: {
    PRODUCTS_COMMENTS: { BASE_URL: PRODUCTS_COMMENTS_BASE_URL },
  },
} = PATHNAME;

type FieldType = Pick<
  ReturnType<typeof useProductCommentValue>,
  'content' | 'status'
>;

const ProductCommentForm = () => {
  const [form] = Form.useForm<FieldType>();
  const {
    id = '',
    replies = [],
    defaultStatus,
    mode,
  } = useProductCommentValue();
  const navigate = useNavigate();

  const formatedReplies = replies.filter(({ content }) => {
    const parsedContent = parseFromContent(content);

    if (parsedContent) {
      const parsedTextContent = parsedContent.textContent || '';
      return parsedTextContent.trim();
    }

    return false;
  });

  const onFinish = useLockFn(
    async ({ content = '', status = defaultStatus! }: FieldType) => {
      const params: Parameters<typeof updateProductComment>[0] = {
        id,
      };
      const body: Parameters<typeof updateProductComment>[1] = {
        content,
        replies: formatedReplies,
        status,
      };

      switch (mode) {
        case 'Update': {
          return updateProductComment(params, body)
            .then(() => {
              notification.success({
                message: 'دیدگاه مورد نظر با موفقیت ویرایش شد.',
              });
              navigate(PRODUCTS_COMMENTS_BASE_URL);
            })
            .catch(message => {
              notification.error({ message });
            });
        }
        default:
          break;
      }
    },
  );

  return (
    <PrimitiveForm form={form} onFinish={onFinish}>
      <Flex
        className='*:flex-1 *:rounded *:bg-white max-xl:flex-col max-xl:last:*:sticky max-xl:last:*:inset-x-0 max-xl:last:*:bottom-0 max-xl:last:*:z-10 max-xl:last:*:shadow-inner xl:items-start xl:first:*:max-w-[70%] xl:last:*:max-w-[30%]'
        gap='large'
      >
        <ProductCommentFormContent />
        <ProductCommentFormAction />
      </Flex>
    </PrimitiveForm>
  );
};

export { ProductCommentForm };
